module.exports = __webpack_public_path__ + "img/logo-bizmob-text-white.03bad1bf.png";